import A from '@/gf/components/A'
import Card from '@/gf/components/Card'
import useConfig from '@/gf/hooks/useConfig'

/**
 * Fallback for public paths (`/~/…`). Those are served to anyone, signed in or not, so
 * the session under them has no user — nothing on this page may read one. There are no
 * public routes left in the buyers app (the last, `/~/dealer-invitation/:token`, went
 * with the dealer-invite feature in 2023), so every public path lands here.
 */
const PublicNotFound = () => {
  const config = useConfig()

  return (
    <div className="p-8 bg-gray-50 h-screen" data-testid="public-page">
      <div className="flex justify-center">
        <Card title="This link isn't available." className="max-w-sm">
          <Card.Section>
            It may have expired or been removed. If you have a Gearflow account,{' '}
            <A.T href={`${config.loginBaseUrl}/login`}>sign in</A.T> to find what you were sent.
          </Card.Section>
        </Card>
      </div>
    </div>
  )
}

export default PublicNotFound
